import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@/components/atoms";
import { DataTable } from "@/components/molecules";
import { FixedPricingLocation } from "@/redux/slices/trip/types";
import { generateFixedPricingColumns, generateFixedPricingData } from "../helpers";

interface LocationBasedTableProps extends React.HTMLAttributes<HTMLDivElement> {
  pricing: FixedPricingLocation;
}

export const LocationBasedTable = ({ pricing, className, ...props }: LocationBasedTableProps) => {
  const navigate = useNavigate();
  const { baseInterval, intervals, currency, pickupLocation, distanceUnit } = pricing;

  const data = useMemo(
    () => generateFixedPricingData(baseInterval, intervals, currency, distanceUnit),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intervals]
  );

  const columns = useMemo(
    () => generateFixedPricingColumns(distanceUnit),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={className} {...props}>
      <div className="flex items-center">
        <div className="flex-1">
          <Typography variant="h3" className="leading-8">
            {pickupLocation.name}
          </Typography>
          <Typography className="text-neutral-dark-gray">{pickupLocation.address}</Typography>
        </div>
        <div className="flex-shrink-0">
          <Button startIcon="Edit2" onClick={() => navigate("edit")} className="bg-primary px-6 hover:bg-primary-dark">
            Edit
          </Button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        className="[&_table]:table-auto overflow-x-auto w-full mt-6"
        emptyState={
          <div className="flex flex-col items-center justify-center bg-white py-28">
            <Button variant="tertiary" size="lg" startIcon="Add" onClick={() => navigate("edit")}>
              Add First Range
            </Button>
            <Typography variant="paragraph" className="mt-3 text-center text-neutral-dark-gray">
              Set up your minimum Trip Cost Location and
              <br />
              add your custom cost ranges
            </Typography>
          </div>
        }
      />
    </div>
  );
};
